import React, { useState } from 'react';
import { API_URL } from '../constants';

export function CambiosTab({ cambios, titulo, noAccion, onConfirmar }) {
  const [procesando, setProcesando] = useState(false);

  const handleAccion = async (idCambio, accion) => {
    setProcesando(true);
    try {
      const path = accion === 'confirmar' ? 'api/cambios-intellisis/confirmar' : 'api/cambios-intellisis/revertir';
      const url = API_URL + `?path=${path}&payload=${encodeURIComponent(JSON.stringify({ id_cambio: idCambio }))}`;
      const res = await fetch(url);
      const result = await res.json();

      if (result.success) {
        if (onConfirmar) await onConfirmar();
      } else {
        alert('❌ Error: ' + result.error);
      }
    } catch (error) {
      alert('Error: ' + error.message);
    } finally {
      setProcesando(false);
    }
  };

  return (
    <div>
      <div className="page-header">
        <div className="page-title"><i className="ti ti-arrows-transfer-up"></i> {titulo}</div>
      </div>

      <div className="card">
        <table className="tabla">
          <thead>
            <tr>
              <th>ID Empleado</th>
              <th>Nombre</th>
              <th>Tipo de Cambio</th>
              <th>Estatus</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>
            {cambios.map(cambio => (
              <tr key={cambio.id}>
                <td><strong>{cambio.id_empleado}</strong></td>
                <td>{cambio.nombre_empleado}</td>
                <td>{(cambio.tipo || '').replace(/_/g, ' ')}</td>
                <td>
                  <span className={`badge ${cambio.estatus === 'Pendiente_Intellisis' ? 'badge-warning' : 'badge-success'}`}>
                    {cambio.estatus === 'Pendiente_Intellisis' ? 'Pendiente' : 'Confirmado'}
                  </span>
                </td>
                <td>
                  {cambio.estatus === 'Pendiente_Intellisis' ? (
                    <button
                      className="btn-small"
                      onClick={() => handleAccion(cambio.id, 'confirmar')}
                      disabled={procesando}
                    >
                      ✓ Confirmar
                    </button>
                  ) : (
                    <button
                      className="btn-small btn-small-warn"
                      onClick={() => handleAccion(cambio.id, 'revertir')}
                      disabled={procesando}
                    >
                      ↩ Revertir
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {cambios.length === 0 && (
          <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>
            No hay cambios
          </div>
        )}
      </div>
    </div>
  );
}
